import React, { useEffect, useState } from "react";
import { Box, Grid, TextField } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useFetchConnectionRuntimeConfigById from "../../hooks/useFetchConnectionRuntimeConfigById";
import { useBreadCrumbContext } from "../../contexts/BreadCrumbContext";
import { IconBtnEditBase } from "../../common/utils/icons";
import Loader from "../../components/Molecules/Loader/Loader";
import { useAppTranslation } from "../../hooks/useAppTranslation";

const ViewConnectionRuntimeConfig: React.FC = () => {
  const { setCurrentBreadcrumbPage } = useBreadCrumbContext();
  const { id: connectionRuntimeConfigId } = useParams();
  const navigate = useNavigate();
  const { t } = useAppTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // hooks
  const [connectionRuntimeConfigData] = useFetchConnectionRuntimeConfigById({
    setIsLoading,
    currentConnectionRuntimeConfigId: connectionRuntimeConfigId,
  });

  useEffect(() => {
    setCurrentBreadcrumbPage({
      name: connectionRuntimeConfigData?.code,
      id: connectionRuntimeConfigData?.id,
    });
    return () => {
      setCurrentBreadcrumbPage({ name: "", id: null });
    };
  }, [connectionRuntimeConfigData]);

  return (
    <Box>
      {isLoading && <Loader isLoading={isLoading} />}
      <Box className="text-box-card compact-text-box-card">
        <Grid container rowSpacing={1.5} columnSpacing={2.5}>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <label className="label-text text-bold">
              {t("connectionRuntimeConfig.view.label.connectionType")}
            </label>
            <div className="form-control">
              {connectionRuntimeConfigData?.connection_type ||
                t("connectionRuntimeConfig.view.na")}
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <label className="label-text text-bold">
              {t("connectionRuntimeConfig.view.label.code")}
            </label>
            <div className="form-control">
              {connectionRuntimeConfigData?.code ||
                t("connectionRuntimeConfig.view.na")}
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <label className="label-text text-bold">
              {t("connectionRuntimeConfig.view.label.maxFileDownloadThreads")}
            </label>
            <div className="form-control">
              {connectionRuntimeConfigData?.max_file_download_threads || 0}
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <label className="label-text text-bold">
              {t("connectionRuntimeConfig.view.label.maxChunkDownloadThreads")}
            </label>
            <div className="form-control">
              {connectionRuntimeConfigData?.max_chunk_download_threads || 0}
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <label className="label-text text-bold">
              {t("connectionRuntimeConfig.view.label.chunkThresholdSize")}
            </label>
            <div className="form-control">
              {connectionRuntimeConfigData?.chunk_threshold_size_in_bytes || 0}
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <label className="label-text text-bold">
              {t("connectionRuntimeConfig.view.label.maxNumOfFileChunk")}
            </label>
            <div className="form-control">
              {connectionRuntimeConfigData?.max_num_of_file_chunk || 0}
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <label className="label-text text-bold">
              {t(
                "connectionRuntimeConfig.view.label.maxNumOfServiceConnections"
              )}
            </label>
            <div className="form-control">
              {connectionRuntimeConfigData?.max_num_of_service_conn || 0}
            </div>
          </Grid>
          <Grid item xs sx={{ justifyContent: "flex-end", display: "flex" }}>
            <label className="label-text text-bold">&nbsp;</label>
            <button
              className="btn-nostyle icon-btn-edit"
              onClick={() =>
                navigate(
                  `/connection-runtime-config/edit/${connectionRuntimeConfigId}`
                )
              }
            >
              <IconBtnEditBase
                ariaLabel={t("connectionRuntimeConfig.view.ariaEdit")}
              />
            </button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ViewConnectionRuntimeConfig;
